import { Component, OnInit } from '@angular/core';

/**
 * Divider between menu items.
 * 
 * Documentation see `MenuComponent`.
 */
@Component({
  selector: 'app-menu-divider',
  templateUrl: './menu-divider.component.html',
  styleUrls: ['./menu-divider.component.scss']
})
export class MenuDividerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
